var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-card", { staticClass: "day-card-items-report" }, [
    _c(
      "div",
      { staticClass: "list" },
      _vm._l(_vm.cardData.cardItems, function (item, index) {
        return _c(
          "div",
          { key: index, staticClass: "box box-border" },
          [
            _c(
              "div",
              { staticClass: "text title-info" },
              [
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.$dataCheck(item.title)) +
                      _vm._s(item.currency && "(" + item.currency + ")")
                  ),
                ]),
                _c("Content", {
                  attrs: {
                    content: item.tooltip,
                    contentCustomr: item.contentCustomr,
                  },
                }),
              ],
              1
            ),
            _c(
              "el-popover",
              {
                attrs: {
                  "popper-class": "chart-popover",
                  placement: "right-start",
                  width: "560",
                  trigger: "hover",
                },
                on: {
                  show: function ($event) {
                    return _vm.showReport(item.chartKey)
                  },
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "popover-content" },
                  [
                    _c("div", { staticClass: "container" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "item" }, [
                          _c("div", { staticClass: "title" }, [
                            _vm._v("环比时间:"),
                          ]),
                          _c("div", { staticClass: "data" }, [
                            _vm._v("昨日(" + _vm._s(item.dayDt) + ")"),
                          ]),
                        ]),
                        _c("div", { staticClass: "item" }, [
                          _c("div", { staticClass: "title" }, [
                            _vm._v("同比时间:"),
                          ]),
                          _c("div", { staticClass: "data" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm
                                    .moment(item.weekDt)
                                    .locale("zh-cn")
                                    .format("dddd")
                                    .replace(/星期/, "上周")
                                ) +
                                "(" +
                                _vm._s(item.weekDt) +
                                ") "
                            ),
                          ]),
                        ]),
                      ]),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "item" }, [
                          _c("div", { staticClass: "title" }, [
                            _vm._v("环比值:"),
                          ]),
                          _c("div", { staticClass: "data" }, [
                            _vm._v(_vm._s(item.dayValue) + _vm._s(item.unit)),
                          ]),
                        ]),
                        _c("div", { staticClass: "item" }, [
                          _c("div", { staticClass: "title" }, [
                            _vm._v("同比值:"),
                          ]),
                          _c("div", { staticClass: "data" }, [
                            _vm._v(_vm._s(item.weekValue) + _vm._s(item.unit)),
                          ]),
                        ]),
                      ]),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "item" }, [
                          _c("div", { staticClass: "title" }, [
                            _vm._v("环比结果:"),
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "data",
                              style:
                                item.dayRate < 0
                                  ? "color:#16C97B"
                                  : "color:#F23E55",
                            },
                            [_vm._v(" " + _vm._s(item.dayRate) + "% ")]
                          ),
                        ]),
                        _c("div", { staticClass: "item" }, [
                          _c("div", { staticClass: "title" }, [
                            _vm._v("同比结果:"),
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "data",
                              style:
                                item.weekRate < 0
                                  ? "color:#16C97B"
                                  : "color:#F23E55",
                            },
                            [_vm._v(" " + _vm._s(item.weekRate) + "% ")]
                          ),
                        ]),
                      ]),
                    ]),
                    _c("reportCard", {
                      ref: item.chartKey,
                      refInFor: true,
                      attrs: {
                        config: _vm.configData[item.chartKey] || {
                          height: "235px",
                        },
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "number font-manrope",
                    attrs: { slot: "reference" },
                    slot: "reference",
                  },
                  [_vm._v(_vm._s(_vm.$dataCheck(item.number, 0)))]
                ),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "rate-box",
                attrs: { slot: "reference" },
                slot: "reference",
              },
              [
                _c("span", { staticClass: "rate" }, [
                  _c("span", [_vm._v("日环比：")]),
                  _c(
                    "span",
                    {
                      staticClass: "font-manrope rate-number",
                      style:
                        item.dayRate < 0 ? "color:#16C97B" : "color:#F23E55",
                    },
                    [_vm._v(" " + _vm._s(_vm.$dataCheck(item.dayRate)) + "% ")]
                  ),
                ]),
                _c("span", { staticClass: "rate" }, [
                  _c("span", [_vm._v("周同比：")]),
                  _c(
                    "span",
                    {
                      staticClass: "font-manrope rate-number",
                      style:
                        item.weekRate < 0 ? "color:#16C97B" : "color:#F23E55",
                    },
                    [_vm._v(" " + _vm._s(_vm.$dataCheck(item.weekRate)) + "% ")]
                  ),
                ]),
              ]
            ),
          ],
          1
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }